var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRocketship = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 494,
    viewBox: "0 0 276 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.6864 312.07L106.045 303.902C107.744 303.395 109.452 304.667 109.452 306.44V406.026C109.452 406.946 108.974 407.8 108.19 408.282L88.2108 420.558C87.7283 420.855 87.3536 421.298 87.1415 421.823L61.3939 485.574C60.9895 486.575 60.0178 487.231 58.938 487.231H4.65159C2.7391 487.231 1.457 485.266 2.22727 483.516L77.0197 313.541C77.3326 312.83 77.942 312.292 78.6864 312.07Z",
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.83 320.233L108.143 314.589C108.81 314.428 109.452 314.933 109.452 315.619V324.945C109.452 325.378 109.183 325.768 108.783 325.935C87.308 334.889 79.3933 354.051 70.809 375.277C70.4767 376.099 69.3427 376.173 68.9057 375.402L65.7306 369.799C65.5745 369.524 65.5498 369.193 65.6632 368.897L84.0902 320.883C84.2149 320.558 84.4915 320.315 84.83 320.233Z",
    fill: "#FA7B6A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4679 319.307L96.7381 317.453M65.4841 368.572L71.0463 355.064M72.8203 349.766L84.2895 320.366",
    stroke: "black",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4801 475.563L59.4589 376.093C60.5569 373.61 64.2357 374.19 64.5158 376.891L65.221 383.69C65.2732 384.194 65.1961 384.669 64.9724 385.123C61.5891 391.99 33.3642 450.457 40.9449 474.86C41.5685 476.867 40.1896 479.283 38.0876 479.283H17.9026C15.9881 479.283 14.706 477.314 15.4801 475.563Z",
    fill: "#FA7B6A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4801 475.563L59.4589 376.093C60.5569 373.609 64.2357 374.19 64.5158 376.891L70.9008 438.457C70.9495 438.927 70.8717 439.401 70.6754 439.831L53.3584 477.735C52.9275 478.678 51.986 479.283 50.9492 479.283H17.9026C15.9881 479.283 14.706 477.314 15.4801 475.563Z",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.275 312.034L169.954 302.065C168.226 301.435 166.398 302.714 166.398 304.553V406.027C166.398 406.947 166.875 407.801 167.66 408.283L187.639 420.559C188.121 420.856 188.496 421.299 188.708 421.824L214.455 485.575C214.86 486.576 215.832 487.232 216.911 487.232H271.198C273.11 487.232 274.392 485.267 273.622 483.517L198.791 313.456C198.501 312.795 197.953 312.282 197.275 312.034Z",
    fill: "#F6F6F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.577 421.5L214.723 486.237C214.966 486.838 215.549 487.232 216.197 487.232H251.084C252.881 487.232 254.262 481.14 251.084 479.815C222.684 460.451 175.138 393.559 175.138 316.394C175.138 282.258 167.232 395.47 166.458 406.629C166.417 407.219 166.713 407.701 167.217 408.011L187.936 420.742C188.225 420.919 188.45 421.185 188.577 421.5Z",
    fill: "#FA7B6A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M186.792 319.574L177.522 317.72M208.776 368.839L203.214 355.331M201.44 350.034L189.971 320.634",
    stroke: "black",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M257.72 475.566L213.742 376.096C212.644 373.612 208.965 374.193 208.685 376.893L202.3 438.46C202.251 438.929 202.329 439.404 202.525 439.833L219.842 477.737C220.273 478.68 221.215 479.285 222.251 479.285H255.298C257.213 479.285 258.495 477.317 257.72 475.566Z",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M197.275 312.034L169.954 302.065C168.226 301.435 166.398 302.714 166.398 304.553V406.027C166.398 406.947 166.875 407.801 167.66 408.283L187.639 420.559C188.121 420.856 188.496 421.299 188.708 421.824L214.455 485.575C214.86 486.576 215.832 487.232 216.911 487.232H271.198C273.11 487.232 274.392 485.267 273.622 483.517L198.791 313.456C198.501 312.795 197.953 312.282 197.275 312.034Z",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.587 438.757C109.657 433.486 114.743 430.021 120.406 430.021H155.947C161.793 430.021 167.002 433.711 168.94 439.226C172.09 448.184 165.442 457.566 155.947 457.566H120.406C110.698 457.566 104.036 447.792 107.587 438.757Z",
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.368 441.192L164.89 438.709C163.92 433.666 159.507 430.021 154.371 430.021C148.455 430.021 143.659 434.816 143.659 440.732V457.566H151.843C160.492 457.566 167.001 449.687 165.368 441.192Z",
    fill: "#FA7B6A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1219 459.421C99.1219 456.934 101.138 454.918 103.625 454.918H171.96C174.446 454.918 176.462 456.934 176.462 459.421C176.462 461.907 174.446 463.923 171.96 463.923H103.625C101.138 463.923 99.1219 461.907 99.1219 459.421Z",
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.722 463.923C170.371 463.923 170.9 456.772 167.722 454.918H137.527V463.923H167.722Z",
    fill: "#FA7B6A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1219 459.421C99.1219 456.934 101.138 454.918 103.625 454.918H171.96C174.446 454.918 176.462 456.934 176.462 459.421C176.462 461.907 174.446 463.923 171.96 463.923H103.625C101.138 463.923 99.1219 461.907 99.1219 459.421Z",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.163 430.231H157.46C166.305 430.231 174.868 423.061 174.868 414.216L173.476 125.247V85.5573C173.476 77.7751 167.925 71.2894 160.567 69.8432C160.132 63.2917 159.472 47.1722 156.651 32.2895C153.648 16.4437 148.197 2 137.964 2C127.736 2 122.268 16.4388 119.301 32.2895C116.512 47.1949 115.706 69.9476 115.694 69.9189C108.517 71.504 103.148 77.9037 103.148 85.5573V125.247L100.711 414.216C100.711 423.061 110.318 430.231 119.163 430.231Z",
    fill: "#F6F6F1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M157.46 430.233C166.305 430.233 174.868 423.062 174.868 414.217L174.536 345.266C161.129 351.199 144.8 291.234 138.312 260.509V430.233H157.46Z",
    fill: "#FA7B6A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.964 2C127.736 2 122.267 16.4388 119.301 32.2895C119.301 32.2895 130.472 27.7635 137.976 27.7635C145.48 27.7635 156.651 32.2895 156.651 32.2895C153.648 16.4437 148.197 2 137.964 2Z",
    fill: "#F6DE05"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.566 69.8432C167.925 71.2894 173.475 77.7751 173.475 85.5573V125.247L173.771 186.611C168.696 76.1621 147.592 73.5134 144.149 68.3544C144.183 68.2355 144.217 68.1062 144.252 67.9668C146.308 59.5537 147.435 14.2457 137.963 2C148.197 2 153.648 16.4437 156.651 32.2895C159.471 47.1722 160.132 63.2917 160.566 69.8432Z",
    fill: "#FA7B6A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M157.146 218.797C150.373 215.63 145.75 210.973 142.628 204.13C141.269 201.174 140.595 198.531 138.057 198.531C135.518 198.531 134.845 201.174 133.485 204.143C130.364 210.973 125.741 215.644 118.967 218.81C116.028 220.183 113.424 221.165 113.424 223.428C113.424 225.691 116.028 226.673 118.967 228.046C125.741 231.213 130.364 235.87 133.485 242.713C134.845 245.682 135.518 248.325 138.057 248.325C140.595 248.325 141.269 245.682 142.628 242.713C145.75 235.883 150.373 231.213 157.146 228.046C160.086 226.673 162.689 225.691 162.689 223.428C162.689 221.152 160.086 220.17 157.146 218.797Z",
    fill: "#FA7B6A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M137.792 67.9509V84.9023M137.792 294.145V279.048M137.792 187.14V172.912M137.792 261.037V272.691M137.792 124.102V131.254",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M160.567 69.8432C167.925 71.2894 173.476 77.7751 173.476 85.5573V125.247L174.684 375.919M160.567 69.8432C160.16 69.7632 149.243 67.7507 137.964 67.8014C126.796 67.8515 115.682 69.8903 115.694 69.9189M160.567 69.8432C160.132 63.2917 159.472 47.1722 156.651 32.2895M115.694 69.9189C108.517 71.504 103.148 77.9037 103.148 85.5573V125.247L101.04 375.223M115.694 69.9189C115.706 69.9476 116.512 47.1948 119.301 32.2895M119.301 32.2895C122.268 16.4388 127.736 2 137.964 2C148.197 2 153.648 16.4437 156.651 32.2895M119.301 32.2895C119.301 32.2895 130.472 27.7635 137.976 27.7635C145.48 27.7635 156.651 32.2895 156.651 32.2895M100.981 382.186L100.711 414.216C100.711 423.061 110.318 430.231 119.163 430.231H157.46C166.305 430.231 174.868 423.061 174.868 414.216L174.714 382.186M100.981 382.186C125.824 378.713 149.871 378.713 174.714 382.186M100.981 382.186L101.04 375.223M174.714 382.186L174.684 375.919M101.04 375.223C126 371.192 149.81 371.401 174.684 375.919",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 141.07,
    cy: 154.132,
    r: 15.9918,
    fill: "#FA7B6A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.892,
    cy: 150.951,
    r: 15.9918,
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.892,
    cy: 150.953,
    r: 11.1458,
    fill: "#1C1C1C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.6,
    cy: 106.457,
    r: 15.9918,
    fill: "#FA7B6A"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.892,
    cy: 103.807,
    r: 15.9918,
    fill: "#F6F6F1",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.892,
    cy: 103.81,
    r: 11.1458,
    fill: "#1C1C1C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8254 433.351C93.8254 430.291 94.3325 427.159 96.1604 424.705C96.5801 424.141 97.0248 423.61 97.4939 423.113C100.056 420.398 103.932 419.655 107.658 419.422C127.419 418.187 147.045 418.15 166.799 419.32C171.488 419.598 176.178 421.326 179.388 424.755C179.48 424.854 179.572 424.954 179.663 425.055C181.641 427.242 182.257 430.246 182.257 433.195C182.257 436.354 181.538 439.547 179.517 441.976C179.237 442.313 178.955 442.635 178.673 442.943C175.968 445.89 171.96 447.085 167.967 447.331C147.826 448.571 127.824 448.562 107.682 447.304C103.94 447.07 100.051 446.311 97.4817 443.582C97.0251 443.097 96.5916 442.58 96.1817 442.033C94.3384 439.572 93.8254 436.425 93.8254 433.351Z",
    fill: "#F6F6F1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M169.576 418.894H144.943V447.499H169.576C173.814 444.851 174.608 423.132 169.576 418.894Z",
    fill: "#FA7B6A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8254 433.362C93.8254 426.067 99.3896 419.954 106.67 419.484C127.637 418.132 148.448 418.128 169.415 419.482C176.694 419.952 182.257 426.066 182.257 433.36V433.36C182.257 440.656 176.693 446.769 169.413 447.239C148.446 448.593 127.635 448.593 106.668 447.239C99.3884 446.769 93.8254 440.657 93.8254 433.362V433.362Z",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8245 434.058H101.31M181.908 434.058H178.948M123.07 434.058H120.981M159.278 434.058H171.289M108.795 434.058H114.634",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134.614 313.071H141.5L146.533 491.997H129.052L134.614 313.071Z",
    fill: "#F6F6F1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M146.533 491.999L141.5 313.073H138.057L137.792 491.999H146.533Z",
    fill: "#FA7B6A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 313.073L139.911 302.885H137.924L138.057 313.073H141.5Z",
    fill: "#FA7B6A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M134.614 313.073H141.501M134.614 313.073L129.052 491.999H146.533L141.501 313.073M134.614 313.073L135.938 302.885H139.911L141.501 313.073",
    stroke: "#1C1C1C",
    strokeWidth: 2.59253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRocketship);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rocketship.ced2e7f16b9a82d08d4d9750f1a98701.svg";